import { axiosFactory, errorHandler, currentPage } from '@/configs/axios'

export const getWorkflowsInboxes = {
  api: (page) => {
    return axiosFactory()
      .auth.get(`workflows/inboxes${page ? `/${currentPage(page)}` : '/'}`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const performWorkflowAction = {
  api: (inboxId, payload) => {
    return axiosFactory()
      .auth.post(`workflows/${inboxId}/actions/`, payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const getWorkflowHistory = {
  api: (contentTypeId, objectId) => {
    return axiosFactory()
      .auth.get(`workflows/histories/${contentTypeId}/${objectId}/`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const getApprovalStatuses = {
  api: () => {
    return axiosFactory()
      .auth.get('workflows/approvals/statuses/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}